import { jsx as H } from "react/jsx-runtime";
import { createContext as Ct, useMemo as v, useCallback as h, useState as w, useRef as m, useEffect as R, useContext as jt } from "react";
import { useReactTable as Be, getGroupedRowModel as et, getCoreRowModel as tt, getPaginationRowModel as kt, getFilteredRowModel as Lt, getSortedRowModel as Jt, getExpandedRowModel as Kt } from "@tanstack/react-table";
import { formatColumnName as nt, handleSortingChange as Yt, getSelectedRowPageFromTable as _t } from "../components/organisms/Table/utils.js";
import { IconButton as $t, TableSortLabel as Ut } from "@mui/material";
import Vt from "@mui/icons-material/KeyboardArrowDown";
import qt from "@mui/icons-material/KeyboardArrowRight";
import ee from "moment-timezone";
var x = /* @__PURE__ */ ((S) => (S.TEXT = "text", S.OPTIONS = "options", S.TIME_RANGE = "time_range", S))(x || {}), ce = /* @__PURE__ */ ((S) => (S.IN = "in", S.NOT_IN = "not_in", S))(ce || {});
const rt = Ct(void 0), Ht = [], Xt = [], Wt = [], Qt = [], Zt = [], te = (S) => {
  const f = S?.id;
  return f != null && f !== "" ? String(f) : JSON.stringify(S);
};
function cn() {
  const S = jt(rt);
  if (!S)
    throw new Error("useTableContext must be used within a TableContextProvider");
  return S;
}
function ln({
  children: S,
  data: f,
  columns: y,
  groupByColumns: l = Wt,
  defaultExpanded: Ne = !0,
  persistExpanded: X = !0,
  persistKey: W,
  persistStrategy: Ae = "reset",
  exclusiveExpandedGroup: Y = null,
  defaultSorting: le = Zt,
  disableFilters: ue = !1,
  defaultColumnFilters: ot = [],
  disableSorting: st = !1,
  emptyStateComponent: it,
  isLoading: at,
  enableVirtualization: N = !1,
  hiddenColumns: fe = Qt,
  height: ct,
  minHeight: lt,
  maxHeight: ut,
  enableSelection: Q,
  onSelectionChange: O,
  selectedRowIndex: _,
  preSelectedRows: T,
  isRowSelectionDisabled: de,
  rowSx: ft,
  headerSx: dt,
  onRowClick: ge,
  onRowRightClick: Ge,
  onRowEnter: he,
  onRowLeave: Se,
  drag: Z = {},
  pagination: u = {},
  search: $ = {},
  footerLeftComponent: gt,
  selectedRowId: M,
  showColumnVisibilitySidebar: I = !1
}) {
  const ne = l.length > 0, A = Be({
    data: ne ? f : Ht,
    columns: ne ? y : Xt,
    getCoreRowModel: tt(),
    getGroupedRowModel: ne ? et() : void 0,
    state: {
      grouping: ne ? l : []
    }
  }), b = v(() => {
    if (l.length === 0) return {};
    const e = {}, n = A.getGroupedRowModel().rows, s = (i) => {
      e[i.id] = !0, i.subRows && i.subRows.length > 0 && i.subRows.forEach((o) => {
        s(o);
      });
    }, r = (i) => {
      const o = i.getIsGrouped() ? l[i.depth] : null;
      if (o) {
        const t = y.find((a) => a.id === o || a.accessorKey === o);
        t?.hideGroupingRow?.(i) ?? !1 ? s(i) : Ne && !t?.hideGroupingValues?.(i) && (e[i.id] = !0);
      }
      i.subRows && i.subRows.forEach(r);
    };
    return n.forEach(r), e;
  }, [Ne, l, A, y, f]), re = v(() => JSON.stringify(b), [b]), p = v(() => {
    if (l.length === 0) return /* @__PURE__ */ new Set();
    const e = /* @__PURE__ */ new Set(), n = A.getGroupedRowModel().rows, s = (r) => {
      r.getCanExpand() && e.add(r.id), r.subRows?.length && r.subRows.forEach(s);
    };
    return n.forEach(s), e;
  }, [l, A, f]), ze = v(() => {
    const e = /* @__PURE__ */ new Set();
    if (l.length === 0) return e;
    const n = (s) => {
      if (s.getIsGrouped()) {
        const r = l[s.depth];
        y.find((o) => o.id === r || o.accessorKey === r)?.hideGroupingRow?.(s) && e.add(s.id);
      }
      s.subRows?.forEach(n);
    };
    return A.getGroupedRowModel().rows.forEach(n), e;
  }, [l, A, y, f]), E = h(() => W || `h9_table_expanded:${typeof window < "u" && window.location && window.location.pathname ? window.location.pathname : "unknown"}:${JSON.stringify(l)}`, [W, l]), me = h(() => {
    try {
      const e = sessionStorage.getItem(E());
      if (!e) return null;
      const n = JSON.parse(e);
      if (typeof n == "boolean")
        return n;
      if (!n || typeof n != "object" || p.size === 0)
        return null;
      const s = {};
      for (const [r, i] of Object.entries(n))
        p.has(r) && (s[r] = !!i);
      return Object.keys(s).length === 0 ? null : s;
    } catch {
      return null;
    }
  }, [p, E]), Pe = h((e) => {
    if (e === !0) return !0;
    const n = {}, s = typeof b == "object" && b !== null ? b : {};
    return p.forEach((r) => {
      r in e ? e[r] && (n[r] = !0) : s[r] && (n[r] = !0);
    }), n;
  }, [p, b]), [P, z] = w(() => {
    if (!X) return b;
    const e = me();
    return e !== null ? Pe(e) : b;
  }), pe = m(!1), ht = h((e) => {
    pe.current = !0, z(e);
  }, []), De = m(JSON.stringify(l)), Ce = m(f.length), U = v(() => Array.from(p).sort().join("|"), [p]), je = m(U), ke = m(re), Le = m(!1);
  R(() => {
    const e = JSON.stringify(l), n = De.current !== e, s = je.current !== U, r = ke.current !== re;
    if (n || s || f.length > 0 && Ce.current === 0 || r) {
      if (X)
        if (Ae === "keep") {
          const i = me();
          z(i !== null ? Pe(i) : b);
        } else {
          try {
            sessionStorage.removeItem(E());
          } catch {
          }
          z(b);
        }
      else
        z(b);
      De.current = e, je.current = U, ke.current = re, p.size > 0 && (Le.current = !0);
    }
    Ce.current = f.length;
  }, [Pe, f.length, p, E, me, l, U, b, re, X, Ae]);
  const Re = m(null), Je = m(null);
  R(() => {
    if (Je.current !== Y && (Je.current = Y, Re.current = null, pe.current = !1), !Y || p.size === 0 || pe.current) return;
    const e = `${Y}::${U}`;
    if (Re.current === e) return;
    const n = (i) => {
      for (const o of i) {
        if (o.getIsGrouped() && String(o.groupingValue ?? "") === Y)
          return o;
        const t = o.subRows?.length ? n(o.subRows) : void 0;
        if (t) return t;
      }
    }, s = n(A.getGroupedRowModel().rows);
    if (!s) return;
    const r = {
      [s.id]: !0
    };
    ze.forEach((i) => {
      r[i] = !0;
    }), Re.current = e, z(r);
  }, [Y, p, ze, U, A]), R(() => {
    if (!X) return;
    const e = typeof P == "object" && P !== null;
    if (!(e && Object.keys(P).length === 0 && !Le.current))
      try {
        if (typeof P == "boolean") {
          sessionStorage.setItem(E(), JSON.stringify(P));
          return;
        }
        const s = {};
        try {
          const r = sessionStorage.getItem(E());
          if (r) {
            const i = JSON.parse(r);
            if (i && typeof i == "object")
              for (const [o, t] of Object.entries(i))
                p.has(o) || (s[o] = !!t);
          }
        } catch {
        }
        if (e) {
          const r = P;
          p.forEach((i) => {
            s[i] = !!r[i];
          });
        }
        sessionStorage.setItem(E(), JSON.stringify(s));
      } catch {
      }
  }, [P, p, E, X]);
  const St = l.length > 0 ? l : [], mt = v(() => {
    const e = le || [], n = new Set(e.map((s) => s.id));
    return l.length > 0 ? [...l.filter((r) => !n.has(r)).map((r) => ({
      id: r,
      desc: !1
    })), ...e] : e;
  }, [le, l]), [F, oe] = w(mt), be = m(JSON.stringify(l));
  R(() => {
    const e = JSON.stringify(l), n = be.current !== e;
    if (n && l.length > 0) {
      const s = new Set(F.map((t) => t.id)), r = le || [], i = new Set(r.map((t) => t.id)), o = l.filter((t) => !s.has(t) && !i.has(t));
      if (o.length > 0) {
        const t = o.map((c) => ({
          id: c,
          desc: !1
        }));
        oe([...t, ...F]);
      }
      be.current = e;
    } else n && (be.current = e);
  }, [l]);
  const se = m("");
  R(() => {
    if (l.length > 0) {
      const e = F.filter((o) => l.includes(o.id)), n = F.filter((o) => !l.includes(o.id)), r = [...l.map((o) => ({
        id: o,
        desc: !1
      })), ...n], i = JSON.stringify(r);
      if (i !== se.current) {
        const o = JSON.stringify(F), t = e.some((c) => c.desc === !0) || e.length > 0 && F.length > 0 && !l.includes(F[0].id) || l.some((c) => !e.some((a) => a.id === c));
        t && o !== i ? (oe(r), se.current = i) : t || (se.current = o);
      }
    } else
      se.current = "";
  }, [F, l]);
  const Ke = m({}), [D, ve] = w(ot), [Ye, Pt] = w($?.defaultSearchValue ?? ""), _e = $?.onSearchChange, pt = h((e) => {
    Pt(e), _e?.(e);
  }, [_e]), $e = h((e, n) => {
    if (!n || n.trim() === "")
      return e;
    const s = n.toLowerCase().trim();
    return e.filter((r, i) => y.some((o) => {
      if (o.enableGlobalFilter === !1)
        return !1;
      let t;
      if (o.accessorFn)
        t = o.accessorFn(r, i);
      else if (o.accessorKey) {
        const d = o.accessorKey.split(".");
        t = r;
        for (const g of d)
          if (t && typeof t == "object")
            t = t[g];
          else {
            t = void 0;
            break;
          }
      }
      t == null && (t = "");
      const c = o?.filterType === x.TIME_RANGE;
      let a;
      if (c && typeof t == "number") {
        const d = String(t).length <= 10 ? t * 1e3 : t, g = o?.timeFormat || "MMM DD, YYYY h:mm A z";
        a = ee(d).tz(o?.timezone || "UTC").format(g).toLowerCase();
      } else
        Array.isArray(t) ? a = t.join(" ").toLowerCase() : a = String(t).toLowerCase();
      return a.includes(s);
    }));
  }, [y]), C = v(() => $e(f, Ye), [f, Ye, $e]), [Ue, Ve] = w({}), [Rt, qe] = w(!1), [bt, He] = w(null), [j, vt] = w(u?.defaultPageSize || 10), [wt, we] = w(0), k = u?.isManualPagination ? u.currentPage || 0 : wt, V = v(() => u?.isManualPagination ? (e) => u.onPaginationChange?.(e) : we, [u]);
  R(() => {
    u?.isManualPagination && u.onPaginationChange && u.onPaginationChange(1);
  }, [u.totalPages]);
  const Xe = u?.hideRowsPerPageSelector, [ye, ie] = w(() => T && T.length > 0 ? new Set(T.map((e) => te(e))) : /* @__PURE__ */ new Set()), yt = h((e, n) => {
    Ve((s) => ({
      ...s,
      [e]: n
    }));
  }, []), Mt = h((e) => {
    qe(!0), He(e);
  }, []), Tt = h(() => {
    qe(!1), He(null);
  }, []), Et = h((e, n, s, r) => {
    ge?.(e, n, s, r);
  }, [ge]), xt = h((e, n, s) => {
    Ge?.(e, n, s);
  }, [Ge]), Ot = h((e, n, s) => {
    he?.(e, n, s);
  }, [he]), It = h((e, n, s) => {
    Se?.(e, n, s);
  }, [Se]), G = h((e) => y.find((n) => n.id === e || n.accessorKey === e), [y]), Me = h((e) => {
    const n = G(e);
    if (!n) return [];
    if (n.filterOptions) {
      const t = Array.from(new Map(n.filterOptions.map((c) => [String(c.value), c])).values()).map((c) => c.value);
      return Ke.current[e] = t, t;
    }
    const s = f.map((o, t) => {
      if (n.accessorFn)
        return n.accessorFn(o, t);
      const c = n.accessorKey;
      if (!c) return;
      const a = String(c).split(".");
      let d = o;
      for (const g of a)
        if (d && typeof d == "object")
          d = d[g];
        else
          return;
      return d;
    }).filter((o) => o != null && o !== "" && !(typeof o == "string" && o.trim() === "")), r = /* @__PURE__ */ new Map();
    s.forEach((o) => {
      const t = String(o);
      r.has(t) || r.set(t, o);
    });
    const i = Array.from(r.values()).sort((o, t) => {
      if (typeof o == "number" && typeof t == "number")
        return o - t;
      if (o instanceof Date && t instanceof Date)
        return o.getTime() - t.getTime();
      if (typeof o == "string" && typeof t == "string")
        return o.localeCompare(t, void 0, {
          numeric: !0,
          sensitivity: "base"
        });
      const c = {
        number: 1,
        string: 2,
        boolean: 3,
        object: 4,
        undefined: 5
      }, a = typeof o, d = typeof t;
      return a !== d ? (c[a] || 6) - (c[d] || 6) : String(o).localeCompare(String(t), void 0, {
        numeric: !0
      });
    });
    return Ke.current[e] = i, i;
  }, [f, G]), Te = v(() => ({
    id: "expander",
    header: () => null,
    cell: ({
      row: e
    }) => e.getCanExpand() ? /* @__PURE__ */ H($t, { onClick: () => e.toggleExpanded(), size: "small", children: e.getIsExpanded() ? /* @__PURE__ */ H(Vt, {}) : /* @__PURE__ */ H(qt, {}) }) : null,
    width: "48px",
    enableSorting: !1
  }), []), Ee = h((e) => {
    const n = e.filter((s) => !fe.includes(s.id || s.accessorKey)).map((s) => {
      const r = s;
      let i = r.cell;
      return r.filterType === x.TIME_RANGE && !r.cell && !r.accessorFn && (i = ({
        row: o,
        column: t
      }) => {
        const c = o.getValue(t.id);
        if (typeof c == "number") {
          const a = String(c).length <= 10 ? c * 1e3 : c, d = r.timeFormat || "MMM DD, YYYY h:mm A z";
          return ee(a).format(d);
        }
        return c;
      }), {
        ...r,
        // Only set when defined - an explicit `cell: undefined` key would
        // override TanStack's default renderer in its defaultColumn merge
        ...i !== void 0 ? {
          cell: i
        } : {},
        enableSorting: r.disableSorting !== void 0 ? !r.disableSorting : !0,
        enableFilter: ue ? !1 : r.disableFilter !== void 0 ? !r.disableFilter : !0,
        enableResizing: !0,
        filterFn: r.filterFn || "customFilter",
        header: ({
          column: o
        }) => {
          let t;
          if (r.header !== void 0)
            if (typeof r.header == "function")
              try {
                const a = r.header;
                t = /* @__PURE__ */ H(a, {});
              } catch {
                t = nt(r.accessorKey);
              }
            else
              t = r.header;
          else
            t = nt(r.accessorKey);
          if (!o.getCanSort())
            return t;
          const c = l.includes(o.id);
          return /* @__PURE__ */ H(Ut, { active: o.getIsSorted() !== !1, direction: o.getIsSorted() === "desc" ? "desc" : "asc", onClick: () => !c && Yt(o.id, oe, l), sx: {
            width: "100%"
          }, children: t });
        }
      };
    });
    return l.length > 0 ? [Te, ...n] : n;
  }, [Te, l, ue, fe]), xe = v(() => Ee(y), [y, Ee]), L = v(() => xe.map((e) => e.id), [xe]), J = v(() => !W || !I ? null : `h9_table_columns:${E()}`, [W, I, E]), [Oe, Ft] = w(() => {
    if (!J) return {};
    try {
      const e = localStorage.getItem(J);
      if (e) {
        const n = JSON.parse(e);
        if (n?.columnVisibility && typeof n.columnVisibility == "object") return n.columnVisibility;
      }
    } catch {
    }
    return {};
  }), [Ie, We] = w(() => {
    if (!J) return L;
    try {
      const e = localStorage.getItem(J);
      if (e) {
        const n = JSON.parse(e);
        if (Array.isArray(n?.columnOrder) && n.columnOrder.length > 0) {
          const s = new Set(L), r = n.columnOrder.filter((o) => s.has(o)), i = L.filter((o) => !r.includes(o));
          return [...r, ...i];
        }
      }
    } catch {
    }
    return L;
  });
  R(() => {
    I && We((e) => {
      const n = new Set(L), s = e.filter((i) => n.has(i)), r = L.filter((i) => !s.includes(i));
      return r.length === 0 ? e : [...s, ...r];
    });
  }, [L, I]), R(() => {
    if (J)
      try {
        localStorage.setItem(J, JSON.stringify({
          columnVisibility: Oe,
          columnOrder: Ie
        }));
      } catch {
      }
  }, [Oe, Ie, J]);
  const Nt = h((e, n) => {
    V(0), ve((s) => {
      if ((G(e)?.filterType || x.OPTIONS) === x.TEXT) {
        const o = s.filter((t) => t.id !== e);
        return n ? [...o, {
          id: e,
          value: n
        }] : o;
      } else if (n && typeof n == "object" && "value" in n && "operator" in n) {
        const t = n.value, c = s.findIndex((a) => a.id !== e ? !1 : a.value === t ? !0 : a.value && typeof a.value == "object" && "value" in a.value ? a.value.value === t : !1);
        return c >= 0 ? s.filter((a, d) => d !== c) : [...s, {
          id: e,
          value: n
        }];
      } else {
        const o = s.findIndex((t) => t.id === e && t.value === n);
        return o >= 0 ? s.filter((t, c) => c !== o) : [...s, {
          id: e,
          value: n
        }];
      }
    });
  }, [G, V]), q = Be({
    data: C,
    columns: xe,
    state: {
      expanded: P,
      grouping: l.length > 0 ? St : [],
      sorting: F,
      columnFilters: D,
      columnSizing: Ue,
      columnVisibility: I ? Oe : void 0,
      columnOrder: I ? Ie : void 0,
      pagination: u?.disablePagination || u?.isManualPagination || N ? void 0 : {
        pageIndex: k,
        pageSize: j
      }
    },
    onExpandedChange: ht,
    onSortingChange: oe,
    onPaginationChange: (e) => {
      u?.isManualPagination || u?.disablePagination || N || we((n) => (typeof e == "function" ? e({
        pageIndex: n,
        pageSize: j
      }) : e).pageIndex);
    },
    autoResetPageIndex: !1,
    onColumnVisibilityChange: I ? Ft : void 0,
    onColumnOrderChange: I ? We : void 0,
    getExpandedRowModel: Kt(),
    getGroupedRowModel: l.length > 0 ? et() : void 0,
    getCoreRowModel: tt(),
    getSortedRowModel: Jt(),
    getFilteredRowModel: Lt(),
    getPaginationRowModel: u?.disablePagination || u?.isManualPagination || N ? void 0 : kt(),
    enableExpanding: l.length > 0,
    enableSorting: !st,
    enableFilters: !0,
    autoResetExpanded: !1,
    manualPagination: u?.isManualPagination,
    filterFns: {
      customFilter: (e, n) => {
        const s = G(n), r = e.getValue(n), i = s?.filterType || x.OPTIONS, o = D.filter((t) => t.id === n).map((t) => t.value);
        if (o.length === 0) return !0;
        if (i === x.TIME_RANGE) {
          const t = o[0];
          if (!t || !t.startTime && !t.endTime) return !0;
          const c = r, a = String(c).length <= 10 ? c * 1e3 : c, d = ee(a).valueOf(), g = t.startTime ? ee(t.startTime).valueOf() : -1 / 0, Fe = t.endTime ? ee(t.endTime).valueOf() : 1 / 0;
          return d >= g && d <= Fe;
        }
        if (i === x.TEXT) {
          const t = o[0];
          if (!t || !t.value) return !0;
          const c = t.value.toLowerCase().trim(), a = r?.toString().toLowerCase() || "";
          return t.operator === ce.IN ? a.includes(c) : !a.includes(c);
        } else {
          let t = ce.IN;
          for (const g of D.filter((Fe) => Fe.id === n))
            if (g.value && typeof g.value == "object" && "operator" in g.value) {
              t = g.value.operator;
              break;
            }
          const c = o.map((g) => g && typeof g == "object" && "value" in g ? g.value : g), d = (Array.isArray(r) ? r : [r]).some((g) => c.includes(g));
          return t === ce.IN ? d : !d;
        }
      }
    },
    filterFromLeafRows: !0,
    groupedColumnMode: "remove",
    columnResizeMode: "onChange",
    onColumnSizingChange: Ve,
    enableColumnResizing: !0
  }), Qe = m(C.length), ae = m(q), Ze = m(f);
  Ze.current = f, R(() => {
    ae.current = q;
  }, [q]);
  const B = m({
    key: "",
    openedIds: /* @__PURE__ */ new Set()
  });
  R(() => {
    if (l.length === 0 || !(M != null)) return;
    const n = `id:${M}`;
    if (B.current.key !== n && (B.current = {
      key: n,
      openedIds: /* @__PURE__ */ new Set()
    }), P !== !0) {
      const a = P;
      for (const d of B.current.openedIds)
        if (!a[d]) return;
    }
    const r = ae.current.getPrePaginationRowModel().rows.find((a) => !a.getIsGrouped() && a.original.id === M);
    if (!r) return;
    const i = r.getParentRows().map((a) => a.id);
    if (i.length === 0) return;
    if (P === !0) {
      i.forEach((a) => B.current.openedIds.add(a));
      return;
    }
    const o = P, t = i.filter((a) => !o[a]);
    if (i.forEach((a) => B.current.openedIds.add(a)), t.length === 0) return;
    const c = {
      ...o
    };
    t.forEach((a) => {
      c[a] = !0;
    }), z(c);
  }, [M, l.length, C.length, P]);
  const K = m({
    key: "",
    lastAutoPage: null
  });
  R(() => {
    if (u?.disablePagination || u?.isManualPagination || N)
      return;
    const e = M != null, n = typeof _ == "number" && _ >= 0;
    if (!e && !n)
      return;
    const s = e ? `id:${M}` : `index:${_}`;
    if (K.current.key !== s && (K.current = {
      key: s,
      lastAutoPage: null
    }), K.current.lastAutoPage !== null && k !== K.current.lastAutoPage)
      return;
    const r = _t(ae.current, j, {
      selectedRowId: M,
      selectedRowIndex: _,
      data: Ze.current
    });
    r !== null && (K.current.lastAutoPage = r, r !== k && we(r));
  }, [M, _, j, C.length, P, k, u?.disablePagination, u?.isManualPagination, N]), R(() => {
    if (u?.disablePagination || u?.isManualPagination || N)
      return;
    if (Qe.current !== C.length) {
      Qe.current = C.length;
      const n = ae.current.getRowCount(), s = Math.ceil(n / j);
      s > 0 && k >= s ? (V(s - 1), K.current.lastAutoPage = s - 1) : s === 0 && k > 0 && (V(0), K.current.lastAutoPage = 0);
    }
  }, [C.length, j, V, u?.disablePagination, u?.isManualPagination, N]), R(() => {
    if (T)
      if (T.length > 0) {
        const e = new Set(T.map((n) => te(n)));
        ie((n) => {
          let s = T.length !== n.size;
          if (!s) {
            for (const r of n)
              if (!e.has(r)) {
                s = !0;
                break;
              }
          }
          return s ? e : n;
        });
      } else T.length === 0 && ie(/* @__PURE__ */ new Set());
  }, [T]), R(() => {
    const e = D.filter((n) => {
      const s = G(n.id);
      if (!s) return !1;
      const r = Me(n.id);
      if (s.filterType === x.TEXT || s.filterType === x.TIME_RANGE) return !0;
      const i = n.value;
      if (i == null) return !1;
      const o = typeof i == "object" && "value" in i ? i.value : i;
      return r.some((t) => t === o);
    });
    e.length !== D.length && ve(e);
  }, [D, G, Me]);
  const At = h((e) => {
    Q && ie((n) => {
      const s = new Set(n);
      return s.has(e) ? s.delete(e) : s.add(e), O && setTimeout(() => {
        if (s.size === 0)
          O([]);
        else {
          const r = f.filter((i) => s.has(te(i)));
          O(r);
        }
      }, 0), s;
    });
  }, [Q, f, O]), Gt = h(() => {
    Q && ie((e) => {
      const r = q.getFilteredRowModel().rows.filter((t) => !de?.(t.original, t.index)).map((t) => te(t.original)), i = r.length > 0 && r.every((t) => e.has(t));
      let o;
      return i ? (o = new Set(e), r.forEach((t) => o.delete(t))) : (o = new Set(e), r.forEach((t) => o.add(t))), O && setTimeout(() => {
        if (o.size === 0)
          O([]);
        else {
          const t = f.filter((c) => o.has(te(c)));
          O(t);
        }
      }, 0), o;
    });
  }, [Q, q, f, O, de]), zt = h((e) => ye.has(e), [ye]), Dt = {
    table: q,
    expanded: P,
    isGroupable: l.length > 0,
    expanderColumn: Te,
    processColumns: Ee,
    groupByColumns: l,
    data: f,
    emptyStateComponent: it,
    isLoading: at,
    hiddenColumns: fe,
    footerLeftComponent: gt,
    // Pagination
    pageSize: j,
    setPageSize: vt,
    currentPage: k,
    setCurrentPage: V,
    hideRowsPerPageSelector: Xe,
    disablePagination: u?.disablePagination,
    rowsPerPageOptions: Xe ? [] : u?.rowsPerPageOptions,
    // Manual pagination
    isManualPagination: u?.isManualPagination,
    onPaginationChange: u?.onPaginationChange,
    onRowsPerPageChange: u?.onRowsPerPageChange,
    totalPages: u?.totalPages,
    currentRowsPerPage: u?.currentRowsPerPage,
    // Filters
    columnFilters: D,
    setColumnFilter: Nt,
    setColumnFilters: ve,
    getUniqueValuesForColumn: Me,
    disableFilters: ue,
    getColumnById: G,
    // Resize
    columnSizing: Ue,
    isResizing: Rt,
    currentResizingColumn: bt,
    handleResize: yt,
    handleResizeStart: Mt,
    handleResizeEnd: Tt,
    // Dimensions
    height: ct,
    minHeight: lt,
    maxHeight: ut,
    enableVirtualization: N,
    // Selection
    enableSelection: Q,
    onSelectionChange: O,
    selectedRows: ye,
    toggleRowSelection: At,
    toggleAllRowsSelection: Gt,
    isRowSelected: zt,
    isRowSelectionDisabled: de,
    selectedRowIndex: _,
    selectedRowId: M,
    preSelectedRows: T,
    // Drag
    isDraggable: Z?.isDraggable,
    onDragStart: Z?.onDragStart,
    onDragEnd: Z?.onDragEnd,
    dragLabelColumnId: Z?.dragLabelColumnId,
    dragCountSuffix: Z?.dragCountSuffix,
    // Search
    searchPlaceholder: $?.searchPlaceholder,
    defaultSearchValue: $?.defaultSearchValue,
    onSearchChange: pt,
    searchLeftComponent: $?.searchLeftComponent,
    disableTableSearch: $?.disableTableSearch,
    // Row interaction
    handleRowClick: Et,
    handleRowRightClick: xt,
    handleRowEnter: Ot,
    handleRowLeave: It,
    onRowClick: ge,
    onRowEnter: he,
    onRowLeave: Se,
    rowSx: ft,
    headerSx: dt,
    // Column visibility sidebar
    showColumnVisibilitySidebar: I
  };
  return /* @__PURE__ */ H(rt.Provider, { value: Dt, children: S });
}
export {
  x as F,
  ln as T,
  ce as a,
  te as g,
  cn as u
};
